import { Helmet } from "react-helmet-async";
import styles from "./fon.module.css";
import { motion } from "framer-motion";
import tit from "../../images/tit.webp";
import { NavLink } from "react-router-dom";

function Fon() {
  return (
    <div className={styles.main}>
      <Helmet>
        <title>Lily-Dance Studio</title>
        <meta name="description" content="Dance and Vocal Classes with Lily" />
        <link rel="canonical" href="https://www.lily-d.com/" />
      </Helmet>
      <motion.div className={styles.main}>
        <img className={styles.image} src={tit} alt="dance" />
      </motion.div>
    </div>
  );
}

export default Fon;

/*return (
  <div className={styles.main}>
    <Helmet>
      <title>Lily-Dance Studio</title>
      <meta name="description" content="Dance and Vocal Classes with Lily" />
      <link rel="canonical" href="https://www.lily-d.com/" />
    </Helmet>
    <motion.div className={styles.main}>
      <img className={styles.image} src={tit} alt="dance" />
      <NavLink to={"/company"} className={styles.link}>
        Enter
      </NavLink>
    </motion.div>
  </div>
);*/
